import Vue from "vue";
import VueRouter from "vue-router";
import { getCookie, ISEND } from "@/js/public";
import { Message } from "view-design";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    component: () =>
      import(/* webpackChunkName: "index" */ "@/views/before/index"),
    redirect: "/index",
    children: [
      {
        path: "/index",
        name: "Content",
        component: () =>
          import(/* webpackChunkName: "content" */ "@/components/content")
      },
      {
        path: "/register",
        name: "Register",
        component: () =>
          import(/* webpackChunkName: "content" */ "@/views/before/register.vue")
      },
      {
        path: "/search",
        name: "Search",
        component: () =>
          import(
            /* webpackChunkName: "userInfo" */ "@/views/before/getOrgList.vue"
          )
      },
      {
        path: "/results",
        name: "Results",
        component: () =>
          import(
            /* webpackChunkName: "userInfo" */ "@/views/before/getResults.vue"
          )
      },
      {
        path: "/search/export",
        name: "SearchExport",
        component: () =>
          import(
            /* webpackChunkName: "userInfo" */ "@/views/before/getOrgList.vue"
          )
      }
    ]
  },
  // {
  //   path: '',
  // },
  // {
  //   path: '/2021',
  //   name: 'Home',
  //   component: () => import(/* webpackChunkName: "about" */ '@/views/before/cotent.vue')
  // },
  // {
  //   path: '/userInfo',
  //   name: 'userInfo',
  //   component: () => import(/* webpackChunkName: "userInfo" */ '@/views/before/userInfo.vue')
  // },
  // {
  //   path: '/getOrgList',
  //   name: 'getOrgList',
  //   component: () => import(/* webpackChunkName: "userInfo" */ '@/views/before/getOrgList.vue')
  // },
  // {
  //   path: '/getOrgList/export',
  //   name: 'export',
  //   component: () => import(/* webpackChunkName: "userInfo" */ '@/views/before/getOrgList.vue')
  // },
  {
    path: "/super",
    component: () =>
      import(/* webpackChunkName: "about" */ "@/components/adminMenu.vue"),
    redirect: "/super/orgList",
    meta: {
      requireAuth: true
    },
    children: [
      {
        path: "orgList",
        name: "orgList",
        component: () =>
          import(/* webpackChunkName: "orgList" */ "@/views/super/orgList.vue"),
        meta: {
          requireAuth: true
        }
      }
    ]
  },
  {
    path: "/admin",
    // name: 'admin',
    component: () =>
      import(/* webpackChunkName: "about" */ "@/components/adminMenu.vue"),
    redirect: "/admin/userInfo",
    meta: {
      requireAuth: true
    },
    children: [
      // {
      //   path: 'caseList',
      //   name: 'caseList',
      //   component: () => import(/* webpackChunkName: "orgList" */ '@/views/admin/caseList.vue')
      // }
      {
        path: "workList",
        name: "workList",
        component: () =>
          import(
            /* webpackChunkName: "orgList" */ "@/views/admin/workList.vue"
          ),
        meta: {
          requireAuth: true
        }
      },
      {
        path: "userInfo",
        name: "userInfo",
        component: () =>
          import(
            /* webpackChunkName: "orgList" */ "@/views/admin/userInfo.vue"
          ),
        meta: {
          requireAuth: true
        }
      }
    ]
  },
  {
    path: "*",
    name: "NotFound",
    component: () =>
      import(/* webpackChunkName: "orgList" */ "@/components/common/404.vue"),
    meta: {
      requireAuth: true
    }
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});
router.beforeEach((to, from, next) => {
  const token = getCookie("readStar") || "";
  const level = getCookie("level") || "";
  // const id = getCookie('id') || ''
  const isLogin = !!token;
  let isKeep = false;
  // if (to.fullPath === "/register" && !ISEND) {
  //   next({ path: "/", replace: true });
  //   return;
  // }
  if (to.fullPath === "/results" && ISEND) {
    next({ path: "/", replace: true });
    return;
  }
  if (!to.meta.requireAuth) {
    isKeep = true;
  }
  if (!isLogin && !isKeep) {
    Message.error(`未登录或登陆过期，请重新登录`);
    next({ path: "/", replace: true });
    return;
  }
  if (isLogin && isKeep) {
    // eslint-disable-next-line eqeqeq
    if (level == 0) {
      // next({ path: `/admin/workList?id=${id}`, replace: true })
      next({ path: `/admin/userInfo`, replace: true });
      return;
    }
    // eslint-disable-next-line eqeqeq
    if (level == 1) {
      next({ path: "/super/orgList", replace: true });
      return;
    }
  }
  next();
});
export default router;
